import React from 'react';
import { DeleteWarning, Buttons, ModalContent } from './styles';
import Button from '../../button';
import { BUTTON_TYPE } from '../../../global/constants';
import ModalHeader from '../modalHeader';

interface Props {
  onOk?: () => void;
  onNo?: () => void;
  onClose?: () => void;
  loading?: boolean;
  modalTitle?: string;
  description?: string;
  cancelLoading?: boolean;
  isDelete?: boolean;
  okText?: string;
  cancelText?: string;
}

const ConfirmationModal: React.FC<Props> = (props) => {
  return (
    <>
      <ModalHeader title={props.modalTitle} onClose={props.onClose} />
      <ModalContent>
        <DeleteWarning>{props.description}</DeleteWarning>
        <Buttons>
          <Button
            title={props.cancelText ? props.cancelText : props.isDelete ? 'Cancel' : 'No'}
            onClick={props.onNo ? props.onNo : props.onClose}
            buttonType='button'
            variant={BUTTON_TYPE.SECONDARY}
            isLoading={props.cancelLoading}
          />
          <Button
            onClick={props.onOk}
            title={props.okText ? props.okText : props.isDelete ? 'Ok' : 'Yes'}
            variant={BUTTON_TYPE.PRIMARY}
            buttonType='button'
            isLoading={props.loading}
          />
        </Buttons>
      </ModalContent>
    </>
  );
};

export default ConfirmationModal;
